import request from "@/utils/request";
// 环境监测
export function environmentMonitoringData(params) {
  return request({
    url: "/mqtt/environmentMonitoringData/page",
    method: "get",
    params,
  });
}
// 能耗监测
export function energyMonitoringData(params) {
    return request({
      url: "/mqtt/energyMonitoringData/page",
      method: "get",
      params,
    });
}
// 固含量
export function slurrySolidContentData(params) {
    return request({
      url: "/mqtt/slurrySolidContentData/page",
      method: "get",
      params,
    });
}
// 外加剂罐
export function additiveTankData(params) {
    return request({
      url: "/mqtt/additiveTankData/page",
      method: "get",
      params,
    });
}
// 获取最新的能耗监测数据
export function getNewList() {
  return request({
    url: "/mqtt/energyMonitoringData/getNewList",
    method: "get",
  });
}